/**
 * Validates a cloudId value read from URL query parameters to prevent Reflected XSS.
 */
const CLOUD_ID_SAFE_PATTERN = /^[a-zA-Z0-9-]{1,128}$/;

/**
 * Returns a safe cloudId string, or empty string if invalid.
 */
export function enforceSafeCloudId(raw: string | null | undefined): string {
	if (raw == null || typeof raw !== 'string') {
		return '';
	}
	const trimmed = raw.trim();
	return CLOUD_ID_SAFE_PATTERN.test(trimmed) ? trimmed : '';
}
